import {cs} from "../../../../../../react/chain-services";
import {ConfirmDialog} from "../../../../common/design2/dialogs/confirm-dialog/confirm-dialog";

export const ConfirmCancel = ({next}) => cs(
    ["confirmDialog", ({}, next) => ConfirmDialog({next})],
    ({confirmDialog}) => next(async () => {
        return await confirmDialog.show({
            actionName: "exit",
            message: "Your list has not been finalized and your current results will be lost.",
            buttons: {
                confirmLabel: "Yes",
            },
        });
    }),
);